const { default: axiosIns } = require('@/libs/axios')

const ScoringService = {
  // GET - ScoringApiController
  async getScoreMultipliers(adTypeId) {
    return axiosIns.get(`admin/score/multipliers?adTypeId=${adTypeId}`)
      .then(response => response.data)
  },
  // PUT - ScoringApiController
  async updateScoreMultiplier(model) {
    return axiosIns.put('admin/score/multipliers', model)
      .then(response => response.data)
  },
  // POST - ScoringApiController
  async debuggScoreMultiplier(model, adTypeId) {
    return axiosIns.post(`admin/score/multipliers/debug?adTypeId=${adTypeId}`, model)
      .then(response => response.data)
  },
}

export default ScoringService
